import { UserMailboxStatus } from "generated/graphql";

export type MailboxConnectionState = "connected" | "disconnected" | "not-connected";

export function getMailboxConnectionState(
    mailboxes: readonly { status: UserMailboxStatus }[],
): MailboxConnectionState {
    if (mailboxes.some(mailbox => mailbox.status === UserMailboxStatus.Active)) {
        return "connected";
    }
    if (mailboxes.some(mailbox => mailbox.status === UserMailboxStatus.Disconnected)) {
        return "disconnected";
    }
    return "not-connected";
}
